
import { defineComponent } from "vue";

export default defineComponent({
  name: "Emoji",
  props: {
    position: {
      type: Number,
      required: true
    },
    codepoint: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
  // setup(props) {
  //   console.log("Child in index", props.position);
  // }
});
